import { Module, createMapper, createComposable } from 'vuex-smart-module';

import { ToastNotificationActions } from './actions';
import { ToastNotificationGetters } from './getters';
import { ToastNotificationMutations } from './mutations';
import { ToastNotificatonState } from './state';

const notificationStore = new Module({
    state: ToastNotificatonState,
    getters: ToastNotificationGetters,
    mutations: ToastNotificationMutations,
    actions: ToastNotificationActions,
});

export const useNotificationStore = createComposable(notificationStore);

export default notificationStore;
export const notificationStoreMapper = createMapper(notificationStore);
